import { runInAction } from "mobx";
import { OrderProduct } from "../../../models/Order/OrderProduct";
import { ProjectSourcingProduct } from "../../../models/ProjectManagement/ProjectSourcingProduct";
import { ProjectSourcingOpsStore } from "../stores/ProjectManagement/ProjectSourcingOpsStore";

const mapOrderProductToSourcingProduct = (
  product: OrderProduct,
): ProjectSourcingProduct => ({
  id: product.id,
  name: product.name || `Product #${product.id}`,
  quantity: Number(product.quantity ?? 0),
  used_quantity: Number(product.used_quantity ?? 0),
  cost_price: Number(product.cost_price ?? product.unit_price ?? 0),
  unit_price: Number(product.unit_price ?? 0),
  selling_price: product.selling_price,
  category_id: product.category_id,
  category_name: product.category_name || "",
  sku: product.sku,
  hsn_code: product.hsn_code,
  gst_percentage: product.gst_percentage,
  customisation_required: product.customisation_required,
  has_psd_templates: product.has_psd_templates,
  image_url: product.image_url,
  image_urls: product.image_urls,
});

export function hydrateProjectSourcingOpsStoreForOrderSir(
  store: ProjectSourcingOpsStore,
  orderProducts: OrderProduct[],
): void {
  runInAction(() => {
    store.products = orderProducts.map(mapOrderProductToSourcingProduct);
    store.purchaseRequestProducts = [];
    store.purchaseRequestBody = {
      ...store.purchaseRequestBody,
      pr_products: [],
      warehouse_id: undefined,
      warehouse_name: undefined,
      warehouse_address: undefined,
    };
    store.selectedSkuVariants.clear();
    store.selectedProductVariants.clear();
  });
}

export function clearProjectSourcingOpsStoreForOrderSir(
  store: ProjectSourcingOpsStore,
): void {
  runInAction(() => {
    store.clearExistingPrProducts();
    store.products = [];
    store.selectedSkuVariants.clear();
    store.selectedProductVariants.clear();
  });
}
